import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_alert, {
    type: "info",
    color: "primary",
    variant: "outlined",
    "colored-border": "",
    class: "mt-4",
    style: {"border-color":"#f9b12a !important","border-radius":"15px"}
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, "Votre compte a bien été crée.")
      ], -1),
      _createElementVNode("p", null, "Un mail pour renseigner votre mot de passe vous a été envoyé.", -1),
      _createElementVNode("p", null, "Pensez à vérifier dans vos spams.", -1),
      _createElementVNode("p", null, "Cliquer sur le bouton pour revenir à l'écran de connexion.", -1)
    ])),
    _: 1
  }))
}